var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M26.72 29.28c-0.736 0-1.248-0.48-1.248-1.216v-2.72c0-1.088-0.48-2.080-1.216-2.944-0.736-0.736-1.856-1.248-2.976-1.248h-10.56c-1.12 0-2.112 0.384-2.976 1.248-0.736 0.736-1.216 1.856-1.216 2.944v2.72c0 0.736-0.48 1.216-1.248 1.216s-1.216-0.48-1.216-1.216v-2.72c0-1.728 0.736-3.424 1.984-4.672 1.216-1.216 2.816-1.952 4.672-1.952h10.688c1.728 0 3.456 0.736 4.672 1.952 1.248 1.248 1.984 2.944 1.984 4.672v2.72c-0.128 0.608-0.736 1.216-1.344 1.216zM16 15.872c-3.552 0-6.528-2.944-6.528-6.528 0-3.552 2.976-6.528 6.528-6.528s6.528 2.976 6.528 6.528c0 3.584-2.944 6.528-6.528 6.528zM16 5.152c-2.208 0-4.064 1.856-4.064 4.064s1.856 4.064 4.064 4.064c2.208 0 4.064-1.824 4.064-4.064s-1.856-4.064-4.064-4.064z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.fb7c11a47ee2d66c7eb64aa11ed9fc03.svg";
export { ForwardRef as ReactComponent };